import React, { useContext, useCallback, useState } from 'react';
import { EmailProvider } from '@mummssoftware/common-ui';
import { getSiteEmailList } from '@mummssoftware/utils/pimReader';
import { isAgencyEnabled, getUserName } from '@mummssoftware/utils/utils';
import { AppContext } from '../App/AppContext';

export function CertEmailProvider({ children }) {
  const { agency, keycloak, currentUser } = useContext(AppContext);
  const [siteEmailList, setSiteEmailList] = useState(null);

  const fetchEmailList = useCallback(async () => {
    if (!agency || !keycloak) return;
    const response = await getSiteEmailList(agency, keycloak);
    setSiteEmailList(response);
  }, [agency, keycloak]);

  const isEmailEnabled = !!isAgencyEnabled(
    window.env?.emailAgency,
    currentUser,
  );
  const getSenderName = useCallback(() => getUserName(currentUser), [
    currentUser,
  ]);

  const config = {
    siteEmailList,
    fetchEmailList,
    isEmailEnabled,
    getSenderName,
  };

  return <EmailProvider config={config}>{children}</EmailProvider>;
}
